/* LANGUAGE REDUX */

const DEFAULT = localStorage.getItem("language") || "ru"

const language = (state = DEFAULT, action) => {

    switch (action.type) {

        case "SET_LANGUAGE":
            localStorage.setItem("language", action.payload)
            return action.payload

        default:
            return state

    }
}

export default language
